import Component from './vertical-divider';
export default Component;
